module.exports = __webpack_public_path__ + "img/blueRight.9483ff96.svg";